import { TrackingEventName } from '@/models/analytics/eventTypes';
import { type DocumentEmailedEventProps } from '@/models/analytics/features/documents';
import { trackSelfDescribingEvent } from '@snowplow/browser-tracker';
import {
  trackDocumentCopiedSpec,
  trackDocumentCreatedSpec,
  trackDocumentDeletedSpec,
  trackDocumentExportedSpec,
  trackDocumentGeneratedSpec,
  trackDocumentSharedSpec,
  trackDocumentSyncedSpec,
  trackDocumentUpdatedSpec,
  trackDocumentViewedSpec,
  trackFormFillingDownloadedSpec,
  type DocumentCopied,
  type DocumentCreated,
  type DocumentDeleted,
  type DocumentExported,
  type DocumentGenerated,
  type DocumentShared,
  type DocumentSynced,
  type DocumentUpdated,
  type DocumentViewed,
  type FormFillingDownloaded,
} from '@snowtype/snowplow';
import type { SnowplowEventMap } from '../trackSnowplowEvent';

export const documentEvents: SnowplowEventMap = {
  [TrackingEventName.DocumentCreated]: (props) =>
    trackDocumentCreatedSpec(props as DocumentCreated),

  [TrackingEventName.DocumentGenerated]: (props) =>
    trackDocumentGeneratedSpec(props as DocumentGenerated),

  [TrackingEventName.DocumentUpdated]: (props) =>
    trackDocumentUpdatedSpec(props as DocumentUpdated),

  [TrackingEventName.DocumentExported]: (props) =>
    trackDocumentExportedSpec(props as DocumentExported),

  [TrackingEventName.DocumentCopied]: (props) =>
    trackDocumentCopiedSpec(props as DocumentCopied),

  [TrackingEventName.DocumentShared]: (props) =>
    trackDocumentSharedSpec(props as DocumentShared),

  [TrackingEventName.DocumentViewed]: (props) =>
    trackDocumentViewedSpec(props as DocumentViewed),

  [TrackingEventName.DocumentDeleted]: (props) =>
    trackDocumentDeletedSpec(props as DocumentDeleted),

  [TrackingEventName.DocumentSynced]: (props) =>
    trackDocumentSyncedSpec(props as DocumentSynced),

  // TODO(snowtype): swap to a generated Spec fn once Snowtype is regenerated
  // (needs console credentials). The URI must match the published schema.
  [TrackingEventName.DocumentEmailed]: (props) =>
    trackSelfDescribingEvent({
      event: {
        schema: 'iglu:com.heidi/document_emailed/jsonschema/1-0-0',
        data: props as DocumentEmailedEventProps,
      },
    }),

  [TrackingEventName.FormFillingDownloaded]: (props) =>
    trackFormFillingDownloadedSpec(props as FormFillingDownloaded),
};
